module.exports = __webpack_public_path__ + "assets/img/20_156.58cdd167.jpg";